import React,{useState} from "react";
import './GlobalGames.css' 
import {getMediaUrl,getEnvUrl} from "../../utils/Api";  
import { toast } from 'react-toastify';
import CreateQuestion from "./popups/createQuestion"
import PlaySound from "./PlaySound";
import {deleteQuestion} from  "../../Services/Games/gamesService" 

let GameQuestions=({questions,pageRerender,game_id})=>{ 
    const [qusModal, setQusModal] = useState(false);
    const [qusData, setQusData] = useState({});  
    let qusModelClose=()=>{
        setQusModal(false)
    } 
    let queData=questions
    let questionDelete=(qus_id)=>{
        if(window.confirm('Are you sure you want to delete this question?')){
            deleteQuestion(qus_id).then((data)=>{
               if(data.status){
                toast.success(data.message)
                pageRerender()
               }
                
            })
        }
        
    }
return(<>  
{queData.map((res,index)=>{
return (
    <>
     <div className="accordion-item" key={index}> 
        <h2 className="accordion-header" id="headingOne">
        <button
            className="accordion-button collapsed prevent-word-break"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${res.id}`}
            aria-expanded="false"
            aria-controls={`collapse${res.id}`}
        >
            {index + 1}.{res.question}  
        </button>
        </h2>
         <div id={`collapse${res.id}`} className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
             <div className="card">
                 <div className="card-body" style={{ padding: '20px' }}> 
                    <div className="row">
                   
                        <center>
                            <img alt="Thumbnail" src={`${getEnvUrl()}/admin/media/banner/${btoa(res?.question_image_key)}?width=400&v=${new Date()}`}   width='400'/>
                        </center> 
                    </div> 

                    <div className="row qm">
                        <div className="form-group col-md-6 qus">
                            <label htmlFor="option1">A) {res.option_a}</label>
                           </div>
                        <div className="form-group col-md-6 qus">
                            <label htmlFor="option2">B) {res.option_b}</label>
                        </div>
                    </div>
                    <div className="row qm">
                        <div className="form-group col-md-6 qus">
                            <label htmlFor="option3">C) {res.option_c}</label>
                        </div>
                        <div className="form-group col-md-6 qus">
                            <label htmlFor="option3">D) {res.option_d}</label>
                        </div>
                    </div>
                    <div className="row t10"> 
                        
                        <div className="form-group col-md-4">
                            <label htmlFor="option2">Question Audio :   <div className="mt-3">
                    <div className="audio-preview">
                    <audio controls src={`${getMediaUrl()}/${res?.audio_key}`} controlsList="nodownload"/>
                    </div>
                  </div>  </label>
                          </div>
                        <div className="form-group col-md-4">
                            <label className='prevent-word-break'for="option2">Correct ans Sound :{res?.cas?.asset_name} {(res?.correct_ans_sound!=null) && <PlaySound assetId={res?.correct_ans_sound} />} </label>
                        </div>
                        <div className="form-group col-md-4">
                            <label className='prevent-word-break' for="option2">Wrong ans Sound : {res?.was?.asset_name} {(res?.wrong_ans_sound!=null) && <PlaySound assetId={res?.wrong_ans_sound} />} </label>
                        </div> 
                        </div>
                        <div className="row t10"> 
                        <div className="form-group col-md-6 ">
                            <label htmlFor="option1">Correct Ans : {res?.correct_ans}</label>
                           </div>
                        <div className="form-group col-md-6 ta">
                        <div className="tooltip-container">
                                <span onClick={() => { setQusData(res); setQusModal(true); }} className="a-edit">
                                    <i className="bi bi-pencil-square"></i>
                                    <span className="tooltip-text">Edit</span>
                                </span>
                            </div>
                            <div className="tooltip-container">
                                <span onClick={() => { questionDelete(res.id); }} className="a-delete">
                                    <i className="bi bi-trash-fill"></i>
                                    <span className="tooltip-text">Delete</span>
                                </span>
                            </div>
                        </div>
                    </div>
                 </div>
             </div>
         </div>
     </div> 
    </>
)
})}
     {qusModal?<CreateQuestion type='EDIT' gameId={game_id} qusData={qusData} isShow={qusModal} close={qusModelClose}   pageRerender={pageRerender}/>:''}
         
</>)
}
export default GameQuestions;

